import * as types from '../../constants/log/sessionLogConstants';

export const sessionLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    searchString,
    callback,
    error
  }
) => ({
  type: types.SESSIONLOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  searchString,
  callback,
  error
});

export const sessionLogList = (list) => ({
  type: types.SESSIONLOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setSessionLogPagination = (
  page, totalCount, beginDate, endDate, searchString
) => ({
  type: types.SET_SESSIONLOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchString,
});

export const sessionLogPageReset = () => ({
  type: types.SESSIONLOG_PAGE_RESET,
});
